import { Directive } from '@angular/core';

@Directive({
  selector: 'sn-button-group, [snButtonGroup]',
  host: { class: 'sn-button-group' },
})
export class SnButtonGroupDirective {}
